import React, {Suspense} from "react";
import {Link} from 'react-router-dom';
import {observer} from 'mobx-react'
import UI from "components/UI";
import message from "common/message/source/MessageSource";
import TbComFileDetail from "domain/main/com/file/detail/TbComFileDetail";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import TbComFile from "domain/main/com/file/TbComFile";
import CommonUtil from "utils/CommonUtil";
import DateUtil from "utils/DateUtil";
import Button from "../buttons";
import PageLoading from "../loading";

export interface UIFileDownloadProps {
    value: TbComFile;
    viewMode: "table" | "simple" | "simple2" | "bizLic" | "fund-download";
    rowNumber?: boolean;
}

export default observer(UIFileDownload);

function UIFileDownload(props: UIFileDownloadProps) {
    // console.log("FileDownloadSimpleMode", props.value.tbComFileMapngDetailList.length)
    const downloadFile = async (tbComFileMapngDetail: TbComFileMapngDetail) => {
        const fileList: { FILE_NM: string; ORG_FILE_NM: string; }[] = await CommonUtil.execute({
            url: "com_fileDownload",
            data: {
                DWLD_ID: tbComFileMapngDetail.getDwldId()
            }
        })
            .then((value: any) => value.FILE_LIST)
            .catch(value => {
            });
        fileList && fileList.forEach(value => {
            const {FILE_NM, ORG_FILE_NM} = value;
            const mineType = tbComFileMapngDetail.mimeType;
            const fileContent = `data:${mineType};base64,${FILE_NM}`

            fetch(fileContent).then((response) => {
                response.blob().then(blobData => {
                    const url = window.URL.createObjectURL(blobData)
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", ORG_FILE_NM);
                    link.click();
                });
            })
        })
    };

    if (props.viewMode === "simple") {
        return (
            <Suspense fallback={<PageLoading/>}>
                <ul>
                    {props.value?.tbComFileMapngDetailList != null &&
                        props.value?.tbComFileMapngDetailList.map((tbComFileMapngDetail: TbComFileMapngDetail) => {
                            return (
                                <li key={tbComFileMapngDetail.getFileDetailId()}>
                                    {/* <i className="ic file">첨부파일</i> */}
                                    <Link to="#" className="tx tx-link"
                                          onClick={() => downloadFile(tbComFileMapngDetail)}>
                                        {tbComFileMapngDetail.getOrginlFileNm()}
                                    </Link>
                                    {' '}
                                    <span>({tbComFileMapngDetail.getFormattedFileSize()} Byte)</span>
                                </li>
                            );
                        })}
                </ul>
            </Suspense>
        );
    }
    if (props.viewMode === "simple2") {
        return (
            <Suspense fallback={<PageLoading/>}>
                <ul>
                    {props.value?.tbComFileMapngDetailList != null &&
                        props.value?.tbComFileMapngDetailList.map((tbComFileMapngDetail: TbComFileMapngDetail) => {
                            return (
                                <div key={tbComFileMapngDetail.getFileDetailId()}>
                                    {/* <i className="ic file">첨부파일</i> */}
                                    <Link to="#" className="tx tx-link"
                                          onClick={() => downloadFile(tbComFileMapngDetail)}>
                                        {tbComFileMapngDetail.getOrginlFileNm()}
                                    </Link>
                                    {' '}
                                    <span>({tbComFileMapngDetail.getFormattedFileSize()} Byte)</span>
                                </div>
                            );
                        })}
                </ul>
            </Suspense>
        );
    }

    if (props.viewMode === "bizLic") {
        return (
            <Suspense fallback={<PageLoading/>}>
                <UI.DataTable
                    dataList={props.value?.tbComFileMapngDetailList != null ? props.value?.tbComFileMapngDetailList : []}
                    rowNumber={props.rowNumber}
                    readOnly={true}
                    columns={[
                        {
                            title: message.get("domain.main.tbComFileDetail.fileNm", "파일 이름"),
                            width: "*",
                            align: "left",
                            render: (tbComFileMapngDetail: TbComFileMapngDetail) => (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a style={{display: "inline", cursor: "pointer"}}
                                   onClick={() => downloadFile(tbComFileMapngDetail)}>
                                    {tbComFileMapngDetail.getOrginlFileNm()}
                                </a>
                            ),
                        },
                        {
                            title: message.get("domain.main.tbComFileDetail.registPsnNm", "등록자"),
                            width: "150px",
                            align: "center",
                            render: (tbComFileDetail: TbComFileDetail) =>
                                <span>{tbComFileDetail.getRegistPsnNm()}</span>,
                        },
                        {
                            title: message.get("domain.main.tbComFileDetail.registDt", "등록일시"),
                            width: "150px",
                            align: "center",
                            render: (tbComFileDetail: TbComFileDetail) =>
                                <span>{DateUtil.toDateFormat(tbComFileDetail.getRegistDt(), "YYYY-MM-DD HH:mm:ss")}</span>,
                        },
                    ]}
                    noDataMessage="데이터가 없습니다."
                />
            </Suspense>
        );
    }

    if (props.viewMode === "fund-download") {
        return (
            <Suspense fallback={<PageLoading/>}>
                {props.value?.tbComFileMapngDetailList != null &&
                    props.value?.tbComFileMapngDetailList.map((tbComFileMapngDetail: TbComFileMapngDetail) => {
                        return (
                            <div className="fund-form-group" key={tbComFileMapngDetail.getFileDetailId()}>
                                <div className="fund-form-items">
                                    <Link to="#" className="tx tx-link"
                                          onClick={() => downloadFile(tbComFileMapngDetail)}>
                                        {tbComFileMapngDetail.getOrginlFileNm()}
                                    </Link>
                                    {' '}
                                    {tbComFileMapngDetail.getFormattedFileSize() !== '' &&
                                        <span>({tbComFileMapngDetail.getFormattedFileSize()} Byte)</span>}
                                </div>
                                <Button color='gray-o' size="md"
                                        onClick={() => downloadFile(tbComFileMapngDetail)}>다운로드</Button>
                            </div>
                        );
                    })}
            </Suspense>
        )
    }

    return (
        <Suspense fallback={<PageLoading/>}>
            <UI.DataTable
                dataList={props.value?.tbComFileMapngDetailList != null ? props.value?.tbComFileMapngDetailList : []}
                rowNumber={props.rowNumber}
                readOnly={true}
                columns={[
                    {
                        title: message.get("domain.main.tbComFileDetail.fileNm", "파일 이름"),
                        width: "*",
                        align: "left",
                        render: (tbComFileMapngDetail: TbComFileMapngDetail) => (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a style={{display: "inline", cursor: "pointer"}}
                               onClick={() => downloadFile(tbComFileMapngDetail)}>
                                {tbComFileMapngDetail.getOrginlFileNm()}
                            </a>
                        ),
                    },
                    {
                        title: message.get("domain.main.tbComFileDetail.fileSizeByte", "파일 크기(Byte)"),
                        width: "150px",
                        align: "right",
                        render: (tbComFileDetail: TbComFileDetail) =>
                            <span>{tbComFileDetail.getFormattedFileSize()}</span>,
                    },
                ]}
                noDataMessage=""
            />
        </Suspense>
    );
}
